import React from 'react';
import PropTypes from 'prop-types';
import flatten from 'lodash/flatten';
import { urlWithLocale, languageForLocale } from '../../../utils/locale';

// This pulls direct from the config because it gets 'yanked' into the head of
// the document so doesn't have context of our store to pull the data from.
import { countries } from '../../../config';

/**
 * The default behaviour for AlternateLinkTags is to generate a full list
 * of alternate URLs for the current page on the assumption that an equivalent
 * exists for every locale supported by each market. The default handler
 * generates a list of alternates on this basis for the supplied pagePath.
 */
const alternateUrlsByCountry = (pagePath) =>
  flatten(
    countries.map((country) =>
      country.languages.map((language) => ({
        href: `https://${country.host}${urlWithLocale(country, pagePath, language)}`,
        hrefLang: languageForLocale(language, country.isoCode),
      })),
    ),
  );

/**
 * Accepts a pagePath representing the URL to have alternate meta tags generated
 * for, and a list of alternate URLs, which defaults to the above
 * alternateUrlsByCountry for the given pagePath, but which can be any arbitrary
 * array of alternate links.
 */
const AlternateLinkTags = ({ pagePath, alternates = alternateUrlsByCountry(pagePath) }) =>
  alternates.length > 1 &&
  alternates.map(({ hrefLang, href }) => (
    <link rel="alternate" hrefLang={hrefLang} href={href} key={hrefLang} />
  ));

AlternateLinkTags.propTypes = {
  pagePath: PropTypes.string.isRequired,
  alternates: PropTypes.arrayOf(
    PropTypes.shape({
      hrefLang: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
  ),
};

AlternateLinkTags.defaultProps = {
  alternates: undefined,
};

export default AlternateLinkTags;
